module.exports = __webpack_public_path__ + "img/rodfrugtmos.905b607d.jpg";